import './DonateSection.scss';
import React, { useState } from 'react';
import { DONATE_SECTION, DONATION_SIZE } from '../../../../const/public/donate-page';
import { DonateTab, PaymentSystem, Currency, currencyToString } from '../../../../types/public/donate-page';
import { API_ROUTES } from '../../../../const/common/api-routes/main-api';
import { getEnvVariable } from '../../../../utils/functions/get-env-variable/get-env-variable';
import { Tabs } from '../../../../components/common/tabs/Tabs';

export const DonateSection = () => {
    const [activeTab, setActiveTab] = useState<DonateTab>(DonateTab.oneTime);
    const [donationAmount, setDonationAmount] = useState<number>(0);
    const [currency, setCurrency] = useState<Currency>(Currency.UAH);

    const currencyString = currencyToString(currency);

    const handleDonateAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let inputValue = e.target.value;

        inputValue = inputValue.replace(/[^0-9]/g, '');
        inputValue = inputValue.replace(/[-+]/g, '');

        setDonationAmount(isNaN(Number(inputValue)) ? 0 : Number(inputValue));
    };

    const handleQuickAmountChange = (amount: number) => {
        setDonationAmount((donationAmount as number) + amount);
    };

    const handleCurrencyChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setCurrency(Number(e.target.value) as Currency);
    };

    const handleSubmit: React.FormEventHandler<HTMLFormElement> | undefined = (e) => {
        e.preventDefault();

        if (donationAmount <= 0 || !Number.isInteger(donationAmount)) {
            return;
        }

        const form = e.currentTarget;

        setTimeout(() => {
            form.submit();
        }, 0);
    };

    return (
        <form
            className="donateSection"
            action={`${getEnvVariable('REACT_APP_BACKEND_URL')}/${API_ROUTES.PAYMENTS.DONATE}`}
            method="post"
            onSubmit={handleSubmit}
            data-testid="donate-section-form"
        >
            <input
                type="hidden"
                name="isSubscription"
                value={(activeTab === DonateTab.subscription).toString()}
            ></input>
            <input type="hidden" name="paymentSystem" value={PaymentSystem.WayForPay}></input>
            <Tabs
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                tabs={[
                    { id: DonateTab.oneTime, label: DONATE_SECTION.ONE_TIME_DONATE },
                    { id: DonateTab.subscription, label: DONATE_SECTION.SUBSCRIPTION, disabled: true },
                ]}
            ></Tabs>
            <div className="donateAmountSection">
                <input
                    name="amount"
                    className="donateAmountInput"
                    value={donationAmount || '0'}
                    onChange={handleDonateAmountChange}
                    placeholder="0"
                />
                <div className="currencySelector">
                    <select name="currency" value={currency} onChange={handleCurrencyChange}>
                        <option value={Currency.UAH}>{currencyToString(Currency.UAH)}</option>
                        <option value={Currency.USD}>{currencyToString(Currency.USD)}</option>
                        <option value={Currency.EUR}>{currencyToString(Currency.EUR)}</option>
                    </select>
                    <span className="arrowIcon">▼</span>
                    <span className="currencyText">{currencyString}</span>
                </div>
            </div>
            <div className="fastDonateOptionsSection">
                <button className="donateFastOptionButton" onClick={() => handleQuickAmountChange(10)} type="button">
                    <span className="donateFastValueText">{DONATION_SIZE[10]}</span>
                    {currencyString}
                </button>
                <button className="donateFastOptionButton" onClick={() => handleQuickAmountChange(50)} type="button">
                    <span className="donateFastValueText">{DONATION_SIZE[50]}</span>
                    {currencyString}
                </button>
                <button className="donateFastOptionButton" onClick={() => handleQuickAmountChange(100)} type="button">
                    <span className="donateFastValueText">{DONATION_SIZE[100]}</span>
                    {currencyString}
                </button>
            </div>
            <button className="donateButton" type="submit">
                {activeTab === DonateTab.oneTime
                    ? DONATE_SECTION.ONE_TIME_DONATE_BUTTON_LABEL
                    : DONATE_SECTION.SUBSCRIPTION_BUTTON_LABEL}
            </button>
        </form>
    );
};
